import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { map } from "rxjs";

export const publicGuard: CanActivateFn = () => {
	const authService = inject(AuthService);
	const router = inject(Router);

	return authService.user$.pipe(
		map((user) => {
			if (user) {
				// If user is logged in, redirect to home
				router.navigate(["/"]);
				return false;
			}
			// If no user, allow access to public routes
			return true;
		}),
	);
};
